import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { getPincodes } from "../api";
import PinChecker from "../components/PinChecker";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServiceAreas() {
  const [pins, setPins] = useState([]);
  useEffect(() => { getPincodes().then(setPins).catch(() => {}); }, []);

  return (
    <Layout>
      <SEO title="Elica Service Areas in Pune | Revive Solutions" description="We currently service Elica appliances in Pune PIN codes 411040, 411001, 411022, 411013 and 411060." canonical="/service-areas" />
      <section className="bg-[#0b1220] text-white py-14">
        <div className="max-w-5xl mx-auto px-6">
          <div className="chip chip-dark mb-4">Coverage</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium leading-tight mb-3">Areas We Serve</h1>
          <p className="text-white/70 max-w-2xl">We are currently active in select Pune PIN codes. If you are outside this list, WhatsApp us – we may be able to add your area soon.</p>
        </div>
      </section>
      <section className="py-14 bg-white">
        <div className="max-w-5xl mx-auto px-6 grid lg:grid-cols-[1fr_380px] gap-10">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-medium mb-6">Serviceable PIN Codes</h2>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
              {pins.map((p) => (
                <div key={p.pincode} className="p-5 border border-neutral-200 rounded-lg bg-white hover-card">
                  <div className="flex items-center gap-2.5 mb-1.5"><MapPin className="w-4 h-4 text-[#e30613]" /><div className="font-display text-2xl">{p.pincode}</div></div>
                  <div className="text-sm text-slate-500">{p.area}</div>
                </div>
              ))}
            </div>
            <div className="mt-8"><Link to="/book-service" className="btn-primary">Book a Service <ArrowRight className="w-4 h-4" /></Link></div>
          </div>
          <aside><PinChecker autoRedirect /></aside>
        </div>
      </section>
    </Layout>
  );
}
